import { useEffect, useState } from "react";
import { useGetOrder } from "../api/get-order.query";

export const useOrderData = (uuid: string) => {
  const [isSelectTimeSlotModalOpen, setIsSelectTimeSlotModalOpen] = useState(false);
  const { data, isLoading, error } = useGetOrder({
    uuid,
    config: {
      useErrorBoundary: false,
    },
  });

  useEffect(() => {
    if (data?.order.visitTime === null) {
      setIsSelectTimeSlotModalOpen(true);
    }
  }, [data]);

  return { data, isLoading, error, isSelectTimeSlotModalOpen, setIsSelectTimeSlotModalOpen };
};
